import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { pingActivity, logPage } from "@/lib/presence";

// Maps the current route + role to a live-activity label. Staff (owner/admin) are not counted.
function activityFor(pathname, role) {
  if (/^\/core-assessment/.test(pathname) || /^\/closer-quiz/.test(pathname)) return "taking_test";
  if (pathname === "/post-job") return "creating_job";
  if (/^\/jobs\/[^/]+$/.test(pathname)) return "viewing_job";
  if (/^\/p\//.test(pathname)) return "viewing_rep";
  if (role === "salesman") return "job_seeker";
  if (role === "business") return "business";
  if (["owner", "admin", "brand_ambassador"].includes(role)) return null;
  return "guest";
}

export default function PresenceTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const activityRef = useRef("guest");

  useEffect(() => {
    const role = user?.role || "";
    const act = activityFor(pathname, role);
    activityRef.current = act;
    if (act) pingActivity(act, role);
    // Log the page for signed-in members (staff are ignored server-side too).
    if (user && ["salesman", "business"].includes(role)) logPage(pathname);
    const id = setInterval(() => {
      if (activityRef.current) pingActivity(activityRef.current, role);
    }, 20000);
    return () => clearInterval(id);
  }, [pathname, user]);

  return null;
}
